import { takeEvery, call, put, take, select } from "redux-saga/effects";
import { ActionType, getType } from "typesafe-actions";
import { IApplicationState } from "../..";
import apiCall from "../../../shared/utils/apiCall";
import { gameSynchronized } from "../../common/actions";
import { changeSettings } from "../../settings/actions";
import { changeProfile } from "../actions";

export default function* watchChangeProfile() {
    yield takeEvery(getType(changeProfile.request), function* ({ payload }: ActionType<typeof changeProfile.request>) {
        yield put(changeSettings({
            general: {
                uiLanguage: payload.language,
                locale: payload.locale
            } as any
        }));

        const { prevLanguage } = yield select(({ settings }: IApplicationState) => ({
            prevLanguage: settings.general.uiLanguage
        }));
        
        if (payload.language !== prevLanguage) {
            const response = yield call(apiCall, {
                params: {
                    section: "user",
                    method: "changeLanguage",
                    language: payload.language
                },
                retryCount: 1,
            });

            if (response) {
                localStorage.setItem('ql::locale', payload.locale);
            }
        }

        yield put(changeProfile.success(payload));

        yield take(getType(gameSynchronized));

        document.location.reload();
    });
}